import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Tooltip from 'flarum/common/components/Tooltip';
import humanTime from 'flarum/common/helpers/humanTime';
import Icon from 'flarum/common/components/Icon';
import classList from 'flarum/common/utils/classList';
import ItemList from 'flarum/common/utils/ItemList';
import app from 'flarum/forum/app';
export default class BlogOverviewItem extends Component {
  titleItems() {
    const article = this.attrs.article;
    const blogMeta = article.blogMeta();
    const items = new ItemList();
    items.add('title', m('[', null, article.title()), 100);
    if (blogMeta && blogMeta.isPendingReview() || article.isHidden()) {
      items.add('hidden', m(Icon, {
        name: "fas fa-eye-slash",
        class: "BlogList-item-hidden"
      }), 80);
    }
    if (blogMeta && blogMeta.isPendingReview()) {
      items.add('pendingReview', m(Tooltip, {
        text: app.translator.trans('fof-blog.forum.review_article.pending_review')
      }, m(Icon, {
        name: "far fa-clock",
        class: "BlogList-item-pendingReview"
      })), 40);
    }
    return items;
  }
  dataItems() {
    const article = this.attrs.article;
    const createdAt = article.createdAt();
    const user = article.user();
    const items = new ItemList();
    items.add('createdAt', m("span", {
      class: "BlogList-item-details-createdAt"
    }, m(Icon, {
      name: "far fa-clock"
    }), " ", createdAt ? humanTime(createdAt) : ''), 100);
    items.add('author', m("span", {
      class: "BlogList-item-details-author"
    }, m(Icon, {
      name: "far fa-user"
    }), " ", user && user.displayName() || app.translator.trans('core.lib.username.deleted_text')), 80);
    items.add('replies', m("span", {
      class: "BlogList-item-details-replies"
    }, m(Icon, {
      name: "far fa-comment"
    }), " ", (article.commentCount() || 1) - 1), 60);
    return items;
  }
  contentItems() {
    const article = this.attrs.article;
    const blogMeta = article.blogMeta();
    const summary = blogMeta && blogMeta.summary() || '';
    const items = new ItemList();
    items.add('title', m("h4", null, this.titleItems().toArray()), 100);
    if (summary) items.add('summary', m("p", null, summary), 80);
    items.add('data', m("div", {
      class: "data"
    }, this.dataItems().toArray()), 60);
    return items;
  }
  getImage() {
    const _this$attrs = this.attrs,
      article = _this$attrs.article,
      defaultImage = _this$attrs.defaultImage;
    const blogMeta = article.blogMeta();
    const featuredImage = blogMeta ? blogMeta.featuredImage() : null;
    return featuredImage ? "url(".concat(featuredImage, ")") : defaultImage;
  }
  view(vnode) {
    const _this$attrs2 = this.attrs,
      article = _this$attrs2.article,
      defaultImage = _this$attrs2.defaultImage;
    const blogMeta = article.blogMeta();
    const tags = article.tags() || [];
    const blogImage = this.getImage();
    const isSized = blogMeta ? blogMeta.isSized() : false;
    return m(Link, {
      href: app.route('blogArticle', {
        id: "".concat(article.slug())
      }),
      className: classList('BlogList-item', {
        'BlogList-item-sized': isSized,
        'BlogList-item-default': !isSized
      }, tags.map(tag => "BlogList-item-category-".concat(tag == null ? void 0 : tag.id())))
    }, m("div", {
      class: classList('BlogList-item-photo', {
        'FoFBlog-default-image': blogImage === defaultImage
      }),
      style: {
        backgroundImage: blogImage
      }
    }), m("div", {
      class: "BlogList-item-content"
    }, this.contentItems().toArray()));
  }
}
flarum.reg.add('fof-blog', 'forum/components/BlogOverviewItem', BlogOverviewItem);